// extracted by mini-css-extract-plugin
module.exports = {"Qty":"qty_Qty__uIOEL","InStock":"qty_InStock__hnMhb","OutOfStock":"qty_OutOfStock__CzYEN"};